import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SacflowComponent } from './components/sacflow.component';
import { SharedModule } from '../../shared/shared.module';
import { StartfundraiserButtonModule } from '../startfundraiser-button/startfundraiser-button.module';
import { ButtonModule } from '../button/button.module';

/**Components */
const components = [
  SacflowComponent
];
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StartfundraiserButtonModule,
    ButtonModule
  ],
  declarations: [
    ...components
  ],
  exports: [
    ...components
  ]
})
export class SacFlowModule { }
